import Video from '@components/Video';
import { useStoreState } from 'easy-peasy';
import classNames from 'classnames';
import { AppBanner } from '@components/AppBanner/index';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { PageStateContext } from '@components/Providers/PageStateProvider';
import { GTM } from '@app/gtm';
import {
  jobCompanyNameSelector,
  jobStoreSelector,
} from '@model/Job/Job.selectors';
import { JOB_PAGE_STATES } from '@model/Job/_constants/Job.constants';

export const SearchingSidebar = () => {
  const { t } = useTranslation();
  const job = useStoreState(jobStoreSelector);
  const companyName = useStoreState(jobCompanyNameSelector);
  const pageState = useContext(PageStateContext);

  const isPageStateDone = pageState === JOB_PAGE_STATES.DONE;

  const wrapperClassNames = classNames('rev-u-px-16 rev-o-col-12', {
    'rev-u-py-8 rev-o-col--medium-3': isPageStateDone,
    'rev-o-col--medium-4': !isPageStateDone,
  });

  const sidebarElementClassNames = classNames('o-sidebar', {
    'o-sidebar--y-bottom': isPageStateDone,
    'o-sidebar--y-center': !isPageStateDone,
  });

  const websiteImageSrc = `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/website.png`;

  const handleDownloadJraClick = () => {
    const eventAction = 'Download JRA';

    GTM.trackGTMEvent({
      action: eventAction,
      label: `${companyName} - ${job.id} - ${job.title}`,
    });

    GTM.trackGA4Event(eventAction, companyName, `${job.id} - ${job.title}`);
  };

  return (
    <div className={wrapperClassNames}>
      <div className={sidebarElementClassNames}>
        {pageState === JOB_PAGE_STATES.TO_DO ? (
          <Video video="smartphone" sources={['webm']} />
        ) : null}

        {pageState === JOB_PAGE_STATES.DOING ? (
          <img
            width="256"
            src="/employer_view/assets/images/website.png"
            alt=""
          />
        ) : null}

        {isPageStateDone && !!job.presentationMeetingSlidesUrl ? (
          <AppBanner
            isLayoutSkyscraper
            title={t('searching.jraCard.title')}
            body={t('searching.jraCard.subtitle')}
            ctaLabel={t('searching.jraCard.download')}
            ctaUrl={job.presentationMeetingSlidesUrl}
            onClick={handleDownloadJraClick}
          />
        ) : null}
      </div>
    </div>
  );
};
